import React, { Component } from "react";
import { NavLink } from 'react-router-dom';
import { Accordion, Card, Button, DropdownButton, Dropdown } from "react-bootstrap";
import MasterService from '../services/MasterService';
// const Navigation = () => {

//     this.state = {
//         activeId: null  // nothing selected by default, but this is up to you...
//     }

//     handleClick(event, id) {
//         this.setState({ activeId: id })
//     }

class Navigation extends Component {
    constructor() {
        super();
        this.state = {
            activeId: null,
            user: JSON.parse(localStorage.getItem('user')) || {}
        }
    }

    handleLogout = async (e) => {
        e.preventDefault();
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            
            if (user && (user.id || user.user_id)) {
                await MasterService.logout(user.id || user.user_id);
            }
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    handleClick(event, id) {
        this.setState({ activeId: id })
    }
    render() {
        return (
            <div className="container-fluid" >
                <div className="header-main">
                    <div className="logo">
                        Auction Box
                    </div>
                    <div className="right-panel-naviganion menupanel">
                        <div className="nav">
                            <ul>
                                <li><NavLink to="/dashboard">Dashboard</NavLink></li>
                                <li><NavLink to="/vehicles">Vehicles</NavLink></li>
                                <li><NavLink to="/auction">Auction</NavLink></li>
                                {/* <li className="dropdownmenu"><NavLink to="/about">Manage Panel</NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                    </ul>
                                </li> */}
                                {/* <li><NavLink to="/ruleengine">Rule Engine</NavLink></li> */}
                                {/* <li className="dropdownmenu"><NavLink to="/contact">Rule Engine</NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                    </ul>
                                </li> */}
                                {/* <li className="dropdownmenu"><NavLink to="#">More</NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                    </ul>
                                </li> */}
                            </ul>
                        </div>
                        {/* <a className="notification-btn">
                            <Notifaction />

                        </a> */}

<div className="user-detail ">
                            <ul>
                                <li className="dropdownmenu"><NavLink to="#">
                                    <span className="userarc">
                                        {this.state.user.name ? this.state.user.name[0].toUpperCase() : (this.state.user.firstName ? this.state.user.firstName[0].toUpperCase() : 'U')}
                                    </span>
                                    <div className="username">
                                        <span>{this.state.user.name || `${this.state.user.firstName} ${this.state.user.lastName}`}</span>
                                    </div>
                                </NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="#" onClick={this.handleLogout}>Logout</NavLink> </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        {/* <div className="user-status">
                            <Dropdown>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                    <div className="status">
                                        <i className="active-status"></i>
                                        <div className="status-txt">
                                            <span>Active</span>
                                            <span className="sub-status"></span>
                                        </div>

                                    </div>



                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <ul className="satus-drop-downlist">
                                        <li className="">
                                            <i className="active-status"></i>
                                            <span>Active</span>
                                        </li>
                                        <li className="active">
                                            <i className="inactive-status"></i>
                                            <span className="">Set as Away</span>
                                            <ul className="away-time-stamp">
                                                <li>
                                                    30 minutes
                                                </li>
                                                <li className="active">
                                                    1 hour
                                                </li>
                                                <li>
                                                    2 hours
                                                </li>
                                                <li>
                                                    4 hours
                                                </li>
                                                <li>
                                                    8 hours
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div> */}
                        {/* <div className="language">
                            <ul>
                                <li className="dropdownmenu">
                                    <NavLink to="#">
                                        ENG
                                    </NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                        <li><NavLink to="/about">Option1</NavLink> </li>
                                    </ul>
                                </li>

                            </ul>
                        </div> */}
                    </div>

                </div>

            </div >
        );
    }
}
export default Navigation;